import PropTypes from 'prop-types';

import { Image } from '../shared';

const ImageSection = (props) => {    
    return (
        <div className='corporate-image-section-container'>
            <Image src={props.imgSrc} alt={props.imgAlt} className='corporate-image-section-image' isOldImage />
            <div className='corporate-image-section-card-container'>
                <h4 className='corporate-image-section-heading'>{props.title}</h4>
                <p className='corporate-image-section-paragraph'>{props.paragraph}</p>
                <h6 className='corporate-image-section-caption'>{props.authorDetails}</h6>
            </div>
        </div>
    );
};

export default ImageSection;

ImageSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
    authorDetails: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
};
